import React from 'react';
import fr from 'facet-rest';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDPrimaryActionButton, FDPrimaryActionIconButton,
  FDStack, FDTextButton,
} from '@facet-wealth/design';
import MetaLayoutRemainingFields from 'Components/UI/Meta/MetaForm/Components/MetaLayout/MetaLayoutRemainingFields';
import { useModalContext } from 'Views/Page/Contexts/ModalContext';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import WizardStepDeleteButton from 'Views/Page/Content/Modal/Layouts/DefaultFDWizardStep/Layout/WizardStepDeleteButton';
import { DialogActions, DialogTitle, DialogContent } from 'Views/Page/Content/Modal/Components';


const Layout = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { clearModalCollection, loadModalCollectionByLink } = useModalContext();

  const handleCancel = () => {
    clearModalCollection();
  };

  async function handleDelete() {
    return resource.delete();
  }

  const onDeleteSuccess = async () => {
    clearModalCollection();
  };

  const isEdit = !!resource.link('self');

  return (
    <>
      <DialogTitle value={isEdit ? 'Edit income' : 'Add income'} />
      <DialogContent scrollKey={resource?.type() + resource?.id()}>
        <FDStack direction={'column'} alignItems={'stretch'} spacing={2}>
          <FDStack spacing={2}>
            <MetaControlField attr={'clientId'} />
          </FDStack>
          <FDStack spacing={2}>
            <MetaControlField attr={'description'} flexGrow={1} />
          </FDStack>
          <FDStack spacing={2} alignItems={'center'} wrap>
            <MetaControlField attr={'frequencyGrossValue'} flexGrow={1} />
            <MetaControlField attr={'annualGrossValue'} flexGrow={1} />
            <MetaControlField attr={'amountIsPerFrequency'} />
          </FDStack>
          <MetaLayoutRemainingFields />
          <MetaControlField attr={'isTaxFree'} />

          {resource.meta().canDelete() ? (
            <WizardStepDeleteButton
              onDelete={handleDelete}
              onDeleteSuccess={onDeleteSuccess}
              dialogProps={{
                title: 'Are you sure?',
                message: 'Removing this item will delete all of its information. This cannot be undone.',
                confirmLabel: 'Remove',
              }}
            />
          ) : null}
        </FDStack>
      </DialogContent>
      <DialogActions>
        {resource.withRelationship(fr.relationships.previousLink.name, (rel) => (
          <FDPrimaryActionIconButton
            icon="chevronLeft"
            onClick={() => {
              loadModalCollectionByLink(rel.link('related').url());
            }}
          />
        ), () => {
          <FDTextButton
            onClick={handleCancel}
            label="Cancel"
          />;
        })}

        <FDPrimaryActionButton
          loading={saving}
          onClick={onSubmit}
          label="Submit"
        />
      </DialogActions>
    </>
  );
};

export default Layout;
